import { observer } from "mobx-react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import IconLocation from "../../../../../../components/icons/icon-location/icon-location";
import { NOTE_TYPE, Note } from "../../../../../../components/note/note";
import ReturnMethodStore from "../../../../stores/return-method-store"
import { Input } from "../../../../../../components/inputs/input/input";
import { SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import { InstrucionsWarningFieldLine } from "../../instructions-warning";
import { ShippingInstructionsChangeTrigger } from "../../../../return-method-types";
import DropOffConnectionField from "../../drop-off-connection-field/drop-off-connection-field";
import { DROP_OFF_LOCATION } from "../../../../constants";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardSettingsStore from "../../../../../../stores/dashboard-settings-store";
import { PROFILE_CAPABILITIES } from "../../../../../../models/ProfileCapabilities";

interface Props {
    returnMethod: ReturnMethodStore;
    validationGroup: IValidationGroup
}

const DropOffLocationsField: React.FC<Props> = observer(({returnMethod, validationGroup}: Props) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-return-method-editor';
    const dropOffLocationsList = returnMethod.getDropOffLocationsList(getTranslation);
    const selectedDropOffLocation = dropOffLocationsList.find(option => option.value === returnMethod.dropOffLocationId); //Due to the change we did to te drop down, any merchant who has custom address or shopify address id as the drop off location id will see "please select" on this field. We have a separate PR to fox this issue

    const returnToDropOffLocationCapability = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.RETURN_METHOD_RETURN_TO_DROP_OFF_LOCATION);

    return (
        <>
            {returnToDropOffLocationCapability.isDropOffLocationSourceSupported && (
                <>
                    <FormFieldLine
                        label={getTranslation("DROP_OFF_LOCATION_SOURCE", scope)}
                        note={getTranslation("DROP_OFF_LOCATION_SOURCE_NOTE", scope)}
                        required={true}
                    >
                        <SelectDropdown
                            options={dropOffLocationsList}
                            value={selectedDropOffLocation}
                            onChange={(v) => returnMethod.setDropOffLocationId(v?.value as string)}
                            required
                            validationGroup={validationGroup}
                        />
                    </FormFieldLine>
                    <InstrucionsWarningFieldLine returnMethod={returnMethod} trigger={ShippingInstructionsChangeTrigger.DROP_OFF_LOCATION} />
                </>
            )}

            {returnToDropOffLocationCapability.isDropOffLocationSourceSupported && returnMethod.dropOffLocationId === DROP_OFF_LOCATION.CUSTOM_ADRESS &&
                <FormFieldLine label="">
                    <Note
                    type={NOTE_TYPE.INFORMATION}
                    IconComponent={IconLocation}
                    body= {
                        <FontBody2>
                           {getTranslation("CUSTOM_ADDRESS_NOTE", scope)}
                        </FontBody2>
                    }
                    />
                </FormFieldLine>
            }
            { returnMethod?.isDropOffWithIntegration() &&
                <DropOffConnectionField returnMethod={returnMethod} validationGroup={validationGroup}/>
            }

            { /** for HR , we get the locator url in shipping instructions so there's no need to show this field for them */

                returnToDropOffLocationCapability.isDropOffLocatorURLSupported && returnMethod?.isLocatorUrlConfigurable() &&
                    <>
                        <FormFieldLine
                            label={getTranslation("DROP_OFF_LOCATOR_URL", scope)}
                            note={getTranslation("DROP_OFF_LOCATOR_URL_NOTE", scope)}
                        >
                            <Input
                                value={returnMethod.dropOffLocatorUrl}
                                onChange={value => returnMethod.setDropOffLocatorUrl(value)}
                            />
                        </FormFieldLine>
                    </>
            }
        </>
    )
});

export default DropOffLocationsField;
